import { render, staticRenderFns } from "./DodajCertifikate.vue?vue&type=template&id=26fc1718&"
import script from "./DodajCertifikate.vue?vue&type=script&lang=js&"
export * from "./DodajCertifikate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports